import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react'
import { ErrorMessage, Field, useFormikContext } from 'formik';
import classNames from 'classnames';
import "./styles/CustomSelect.scss";
import useClickOutside from 'scenes/ProjectMultiStepForm/hooks/useClickOutside';
import { useStateMachine } from 'little-state-machine';

const CustomSelect = ({
  config, 
  selectValues,
  updateField,
  returnValue,
  className,
}) => {
  const { name, initialValue, placeholderMessage, disabled, disabledPlaceholder } = config;
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedValue, setSelectedValue] = useState(initialValue || '');
  const [selectedValueColor, setSelectedValueColor] = useState("");
  const { elementRef } = useClickOutside(setShowDropdown);
  const { state } = useStateMachine();

  useEffect(() => {
    if (state?.isEditProject) {
      setSelectedValue(initialValue || "");
    }
  }, [initialValue]);

  const handleShowDropdown = () => {
    if (!disabled) setShowDropdown(!showDropdown);
  };
  
  const handleClickCurrentOption = (label, value, color) => (e) => {
    e.stopPropagation();
    const returnValueType = returnValue === "label" ? label : value;

    setSelectedValueColor(color);
    setSelectedValue(label);
    updateField(name, returnValueType);
    setShowDropdown(false);
  };
  
  return (
    <Fragment>
      <div
        ref={elementRef}
        className={classNames({
          "bg-transparent": !disabled,
          "disabled-select": disabled,
          "custom-select form-control col-12 position-relative": true,
          [className]: true,
        })}
        onClick={handleShowDropdown}
      >
        <div className={classNames({
            "select__default-option": true,
            [selectedValueColor]: true,
          })}>
          {(() => {
            if (!selectedValue) {
              return !disabled ? placeholderMessage : disabledPlaceholder;
            }
            return selectedValue;
          })()}
        </div>
        {showDropdown && <div className="options bg-white p-3 mt-1">
          {selectValues?.map(({ id, label, value, color = "" }, index) => (
            <div
              key={id}
              className={classNames({
                'select__current-option': true,
                'select__current-option-with-border': index !== selectValues.length-1,
                [color]: true,
              })}
              onClick={handleClickCurrentOption(label, value, color)}
            >
              {label}
            </div>
          ))}
        </div>}
        <Field
          id={name}
          name={name}
          component="select"
          className="select--field"
          value={selectedValue}
        />
      </div>
      <ErrorMessage
        className="form-error-message"
        component="div"
        name={name}
      />
    </Fragment>
  );
}

CustomSelect.defaultProps = {
  config: {
    name: "",
    initialValue: "",
    placeholderMessage: "",
    disabled: false,
    disabledPlaceholder: "",
  },
  selectValues: [],
  returnValue: "label",
  updateField: () => {},
}

export default CustomSelect;